import { render, staticRenderFns } from "./VersionChange.vue?vue&type=template&id=48959c79&scoped=true&"
import script from "./VersionChange.vue?vue&type=script&lang=js&"
export * from "./VersionChange.vue?vue&type=script&lang=js&"
import style0 from "./VersionChange.vue?vue&type=style&index=0&id=48959c79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48959c79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48959c79')) {
      api.createRecord('48959c79', component.options)
    } else {
      api.reload('48959c79', component.options)
    }
    module.hot.accept("./VersionChange.vue?vue&type=template&id=48959c79&scoped=true&", function () {
      api.rerender('48959c79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/VersionChange.vue"
export default component.exports